// Global Types
import { AppState } from 'services/types';

// Global Utils
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

// Global Selectors
// @ts-ignore
import { selectCurrentOrganizationId } from 'services/currentOrganizationId/selectors';

// Local Types
import { HarvestEventDocumentsParamsProps } from './types';

const selectEntityId = (
    state: AppState,
    props: HarvestEventDocumentsParamsProps
): number | undefined => props.entityId;

const selectHarvestEventDocumentsLoadParams = createDeepEqualSelector(
    [selectCurrentOrganizationId, selectEntityId],
    (currentOrganizationId: string | undefined, entityId) => ({
        organizationId: currentOrganizationId,
        filter: {
            eager: 'harvestTimesheet',
            require: {
                $and: [
                    {
                        deletedAt: { $exists: false },
                        'documentSet.event.entity.archivedAt': {
                            $exists: false
                        },
                        'documentSet.event.entityId': entityId,
                        'harvestTimesheet.externalId': { $exists: true }
                    }
                ]
            },
            fields: [
                'createdAt',
                'uuid',
                'submittedAt',
                'personIds',
                'harvestTimesheet.externalId'
            ]
        }
    })
);

export { selectHarvestEventDocumentsLoadParams };
